import type { TTourFiltersState } from '@/entities/filter/store/types/tour/state';

export const tourMapFilterDataToSogu = (data: Partial<TTourFiltersState>) => {
  const startDate = data.date?.from ?? null;
  const endDate = data.date?.to ?? null;
  const startDuration = data.duration?.[0]?.toString() ?? null;
  const endDuration = data.duration?.[1]?.toString() ?? null;

  return {
    persons_count: data.persons || null,
    price_start: data.price?.[0] || null,
    price_end: data.price?.[1] || null,
    date_start: startDate || null,
    date_end: endDate || null,
    type: data.tourFormat?.length ? [...new Set(data.tourFormat)] : null,
    activity_type: (data.toursActivities || []).join(',') || null,
    sorting: data.sorting || null,
    start_duration: startDuration,
    end_duration: endDuration,
    children_allowed: data.childrenAllowed || null,
    comfort_type: data.comfort_type || null,
    activity_level_category: data.activity_level_category || null,
    accommodation_type: data.accommodation_type || null,
  };
};
